export default "__VITE_ASSET__b0143f16__"